export default __webpack_public_path__ + "static/media/ashima.0a294d25.jpeg";